import { observer } from "mobx-react-lite";
import { useAuthStore } from "../hooks";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";
import { useTran } from "@/hooks";
import { Feature_NAMESPACES } from "@/lib/i18n";

export const SessionWarningDialog = observer(() => {
  const { t } = useTran(Feature_NAMESPACES.AUTH);
  const authStore = useAuthStore();

  return (
    <Dialog
      open={authStore.showSessionWarning}
      onOpenChange={() => {
        authStore.dismissSessionWarning();
      }}
    >
      <DialogContent
        className="sm:max-w-md"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/20">
              <Clock className="h-5 w-5 text-orange-600 dark:text-orange-500" />
            </div>
            <DialogTitle>{t("auth.session.warningTitle")}</DialogTitle>
          </div>
        </DialogHeader>

        <DialogDescription className="py-4">
          {t("auth.session.warningDescription")}
        </DialogDescription>

        <DialogFooter className="pt-2">
          <Button variant="outline" onClick={authStore.dismissSessionWarning}>
            {t("auth.session.dismiss")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

SessionWarningDialog.displayName = "SessionWarningDialog";
